import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { InformationDataService } from '@app/information/services/information-data.service';
import { AzureBlobStorageService } from '@app/shared/services/api/azure-blob-storage.service';
import { MunicipalityService } from '@app/shared/services/api/municipality.service';
import { environment } from '@env/environment';
import * as moment from 'moment';
import { of, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-information-preview',
  templateUrl: './information-preview.component.html',
  styleUrls: ['./information-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InformationPreviewComponent implements OnInit, OnChanges {
  @Input() data: any[] = [];
  municipalitySubscription: Subscription = new Subscription();
  isMunicipalityDeactivated = false;

  constructor(
    public azBlobStorage: AzureBlobStorageService,
    private router: Router,
    private informationDataService: InformationDataService,
    public municipalityService: MunicipalityService
  ) {}

  ngOnInit() {
    this.filterData();
  }

  ngOnChanges() {
    this.filterData();
  }

  filterData() {
    this.data.forEach((a) => this.formatData(a));
    this.data = this.informationDataService.sortRecords(this.data);
  }

  formatData(data: any) {
    if (data.typeId === 1 || data.typeId === 3) {
      const date = data.modifiedOn;
      data.dateDisplay = moment(date).format('ddd, D MMM YYYY').replace('.', '');
    }

    if (data.typeId === 2 && data.validFrom && data.validTo) {
      const parsedDate = new Date(data.validFrom);
      const eventDate = new Date(
        Date.UTC(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate(), parsedDate.getHours(), parsedDate.getMinutes(), 0, 0)
      );
      const dateFrom = moment(eventDate).format('ddd, D MMM YYYY').replace('.', '');
      const timeFrom = data.setTimeFrom ? moment(eventDate).format('HH:mm') : '';
      data.dateDisplay = `${dateFrom} ${timeFrom}`;
    }

    if (data.image) {
      data.pic = this.azBlobStorage.getBlobImageUrl(`${environment.tenant}/information/${data.id}/${data.image}`);
    } else {
      data.pic = of('');
    }

    data.attachments = [];
    this.azBlobStorage
      .getFiles(`information/${data.id}/attachments`)
      .pipe(take(1))
      .subscribe((a) => (data.attachments = a));

    return data;
  }

  trackByFn(_: number, item: any) {
    return item.id;
  }

  select(info: any) {
    if (!this.isMunicipalityDeactivated) {
      this.informationDataService.highlightId = info.id;
      this.router.navigate(['/informationen']);
    }
  }
}
